import { useCallback, useEffect, useState } from 'react';
import { getPartnerCustomMovements } from 'modules/partners/api/getPartnerCustomMovements';
import { CustomMovement } from 'types';

export const usePartnerMovements = (
  partnerId: string,
  societyId: string,
  isAxaSociety: boolean
) => {
  const [customMovements, setCustomMovements] = useState<CustomMovement[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchPartnerMovements = useCallback(async () => {
    if (!isAxaSociety || !partnerId || !societyId) return;

    try {
      setIsLoading(true);
      setIsError(false);

      const customMovements = (await getPartnerCustomMovements({
        partnerId,
        societyId,
      })) as CustomMovement[];

      setCustomMovements(customMovements);
    } catch (error) {
      console.error('Failed to fetch partner movements:', error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [isAxaSociety, partnerId, societyId]);

  useEffect(() => {
    fetchPartnerMovements();
  }, [fetchPartnerMovements]);

  return {
    customMovements,
    isLoading,
    isError,
    refetch: fetchPartnerMovements,
  };
};
